import { useState, useEffect } from 'react';
function useVisualViewportSize() {
    const hasApi = !!window.visualViewport;
    const isClient = typeof window !== 'undefined';
    const [visualViewportSize, setVisualViewportSize,] = useState({ height: window.innerHeight, width: window.innerWidth });
    useEffect(() => {
        // Do nothing if we're not in web env
        if (!isClient || !hasApi) {
            return () => { };
        }
        // Handler to call on window resize
        function handleResize() {
            // capture event
            const { width, height } = window.visualViewport ?? {};
            if (!width || !height) {
                return;
            }
            const newDimensions = { width, height };
            setVisualViewportSize(newDimensions);
        }
        // Add event listener
        window.visualViewport?.addEventListener('resize', handleResize);
        // Remove event listener on cleanup
        return () => window.removeEventListener('resize', handleResize);
    }, []); // Empty array ensures that effect is only run on mount
    return visualViewportSize;
}
export default useVisualViewportSize;
//# sourceMappingURL=useVisualViewportSize.js.map